<template>
  <div v-loading="loading" style="min-height: 150px">
    <no-data v-if="isNoData" />
    <!-- <div style="margin: 0 0 20px">
      <el-button type="primary" @click="exportData" :loading="exportLoading">导出</el-button><span style="margin-left: 25px;color: red">如果实际结算金额为零时，请代理商先发布完合同信息后，再关注，谢谢！</span>
    </div> -->
    <Collapse
      v-for="(address, key, index) in addressList"
      :key="index"
      :open="true"
    >
      <div v-if="isInternational" slot="header" style="font-size: 15px">
        <span>
          <span>配送至：</span>
          <span class="mr-10">{{ address.address }}</span>
          <span class="mr-10">{{ address.consignee }}</span>
          <span class="mr-10">{{ address.tel }}</span>
        </span>
        <!-- 显示规则：openFlag： Y，不是财务用户 -->
        <el-button
          v-if="address.openFlag ==='Y' && !isFinance"
          type="text"
          style="padding: 0; margin-left: 15px"
          @click.stop="updateAddress(address, key)"
        >
          更改地址
        </el-button>
      </div>
      <!-- <div :style="(contractType !== '国际业务下单' && contractType !== '国际分销下单')? 'padding: 0px 10px 15px' : 'padding: 15px 10px'"> -->
      <div>
        <div v-if="!isInternational" class="marginBottom">
          <span>收货地址：{{ key }}</span>
          <el-button
            type="text"
            style="padding: 0; margin-left: 15px"
            @click.stop="updateAddress(address, index, key)"
          >
            更改地址
          </el-button>
        </div>
        <el-table
          :data="!isInternational? address : address.productList"
          border
          style="width: 100%"
          :summary-method="(data) => getSummaries(data, (!isInternational? address[0] : address))"
          show-summary
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
            align="left"
          />
          <el-table-column
            prop="productInvoiceName"
            label="商品名称"
            align="left"
            min-width="150"
          />
          <el-table-column
            prop="productName"
            label="规格型号"
            align="left"
            min-width="150"
          />
          <el-table-column prop="count" label="数量" align="left" width="60">
            <template v-slot="{ row }">
              {{ $numToFixed(row.count, 0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="productUnit"
            label="单位"
            align="left"
            width="60"
          />
          <el-table-column prop="productUnitPrice" label="单价" align="right" header-align="left">
            <template v-slot="{ row }">
              {{ Number(row.productUnitPrice).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="addTaxesPrice" label="订单金额" align="right" header-align="left">
            <template v-slot="{ row }">
              {{ Number(row.addTaxesPrice).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="expectedDeliveryDate"
            label="期望发货日期"
            width="150"
            align="left"
          >
            <template v-slot="{ row }">
              {{ row.expectedDeliveryDate.substr(0, 10) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="beforeSplitPrice"
            label="拆分前单价"
            align="right"
            header-align="left"
          />
          <el-table-column prop="amount" label="实际结算金额" align="right" header-align="left">
            <template v-slot="{ row }">
              {{ Number(row.amount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="buyPsc" label="是否购买PSC" align="left" />
          <el-table-column
            prop="shippedCount"
            label="已发货数量"
            align="left"
            width="90"
          >
            <template v-slot="{ row }">
              {{ Number(row.shippedCount).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="unShippedCount"
            label="未发货数量"
            align="left"
            width="90"
          >
            <template v-slot="{ row }">
              {{ Number(row.unShippedCount).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="sellingBack"
            label="销退数量"
            align="left"
            width="90"
          >
            <template v-slot="{ row }">
              {{ Number(row.sellingBack).toFixed(0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="taxName"
            label="税收分类名称"
            align="left"
            width="100"
          />
          <el-table-column
            prop="taxRate"
            label="税率"
            align="right"
            width="80"
            header-align="left"
          >
            <template v-slot="{ row }">
              {{ row.taxRate || '0' }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="pname"
            label="序列号"
            align="left"
            width="60"
          >
            <template v-slot="{ row }">
              <lookserial-number
                :str-contract-code="strContractCode"
                :product-name="row.productName"
              />
            </template>
          </el-table-column>
          <el-table-column label="是否冲销" align="left" width="80">
            <template v-slot="{ row }">
              {{ row.isBorrow === 'Y' ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="initInfo.manufactureRefurbished"
            label="是否官翻机"
            align="left"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.manufactureRefurbished ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="contratType == '国际分销下单'"
            prop="serviceDesc"
            label="服务备注"
            align="left"
          />
        </el-table>
      </div>
    </Collapse>
    <div v-if="!isInternational" style="margin-top: 20px">
      <el-table
        id="totalTable"
        :data="allList"
        border
        style="width: 100%"
        :summary-method="getSummariesAll"
        show-summary
      >
        <el-table-column
          type="index"
          width="50"
          label="序号"
          align="left"
        />
        <el-table-column
          prop="productInvoiceName"
          label="商品名称"
          align="left"
          min-width="150"
        />
        <el-table-column
          prop="productName"
          label="规格型号"
          align="left"
          min-width="150"
        />
        <el-table-column prop="count" label="数量" align="left" width="60">
          <template v-slot="{ row }">
            {{ $numToFixed(row.count, 0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="productUnit"
          label="单位"
          align="left"
          width="60"
        />
        <el-table-column prop="productUnitPrice" label="单价" align="right" header-align="left">
          <template v-slot="{ row }">
            {{ Number(row.productUnitPrice).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="addTaxesPrice" label="订单金额" align="right" header-align="left">
          <template v-slot="{ row }">
            {{ Number(row.addTaxesPrice).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="expectedDeliveryDate"
          label="期望发货日期"
          width="150"
          align="left"
        >
          <template v-slot="{ row }">
            {{ row.expectedDeliveryDate.substr(0, 10) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="beforeSplitPrice"
          label="拆分前单价"
          align="right"
          header-align="left"
        />
        <el-table-column prop="amount" label="实际结算金额" align="right" header-align="left">
          <template v-slot="{ row }">
            {{ Number(row.amount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="buyPsc" label="是否购买PSC" align="left" />
        <el-table-column
          prop="shippedCount"
          label="已发货数量"
          align="left"
          width="90"
        >
          <template v-slot="{ row }">
            {{ Number(row.shippedCount).toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="unShippedCount"
          label="未发货数量"
          align="left"
          width="90"
        >
          <template v-slot="{ row }">
            {{ Number(row.unShippedCount).toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sellingBack"
          label="销退数量"
          align="left"
          width="90"
        >
          <template v-slot="{ row }">
            {{ Number(row.sellingBack).toFixed(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="taxName"
          label="税收分类名称"
          align="left"
          width="100"
        />
        <el-table-column
          prop="taxRate"
          label="税率"
          align="right"
          width="80"
          header-align="left"
        >
          <template v-slot="{ row }">
            {{ row.taxRate || '0' }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="pname"
          label="序列号"
          align="left"
          width="60"
        >
          <template v-slot="{ row }">
            <lookserial-number
              :str-contract-code="strContractCode"
              :product-name="row.productName"
            />
          </template>
        </el-table-column>
        <el-table-column label="是否冲销" align="left" width="80">
          <template v-slot="{ row }">
            {{ row.isBorrow === 'Y' ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="initInfo.manufactureRefurbished"
          label="是否官翻机"
          align="left"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.manufactureRefurbished ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="contratType == '国际分销下单'"
          prop="serviceDesc"
          label="服务备注"
          align="left"
        />
      </el-table>
    </div>
    <address-box
      :prop-open.sync="showAddress"
      @chooseAddress="changeAddress"
    />
  </div>
</template>
<script type="es6">
import Collapse from '@/components/Collapse';
import noData from '@/components/noData';
import lookserialNumber from './lookserialNumber';
import addressBox from '@/views/address/index.vue';
import {
  updateContractReceiptAddress, queryOrderInfoFromDsData, queryOrderInfoFromDsDataByAddress,
  updateContractReceiptAddressByLine
} from '@/API';
import Big from 'big.js';
import { getNum, numToFixed } from '@/libs/util';

export default {
  data () {
    return {
      tableData: [],
      isNoData: false,
      loading: false,
      addressList: [],
      exportLoading: false,
      nowAddressIndex: null,
      keyAddress: null,
      showAddress: false,
      contratType: '',
      allList: [],
      baseInfo: null
    };
  },
  props: {
    strContractCode: {
      type: String,
      required: true
    },
    initInfo: {
      type: Object,
      default: () => { return {}; }
    },
    contractType: {
      type: String,
      default: () => { return ''; }
    },
    // 1现销2赊销
    salesType: {
      type: Number,
      required: true
    }
  },
  watch: {
    initInfo: {
      deep: true,
      immediate: true,
      handler (newVal) {
        this.baseInfo = newVal;
      }
    },
    contractType (val) {
      this.contratType = val;
    }
  },

  computed: {
    // 是否财务用户
    isFinance () {
      return this.$store.state.enumeration.telegraphicTransferAuth.includes(this.$store.state.user.userId);
    },
    isInternational () {
      if (!this.baseInfo) return false;
      return this.baseInfo.contractType.startsWith('国际') || (this.baseInfo.contractType === '服务订单' && this.baseInfo.civilInternational);
    }
  },

  components: {
    Collapse,
    noData,
    lookserialNumber,
    addressBox
  },

  mounted () {
    debugger;
    this.initData();
  },

  methods: {
    changeAddress (val) {
      if (this.baseInfo && !this.baseInfo.asInterDirect) {
        // 线上case--渠道项目临时补救
        let newKey = val.province + val.city + val.county + val.receiptAddress + val.receiverName + val.receiverPhone;
        const _items = this.addressList[this.keyAddress];
        let params = {
          receiptAddressId: val.id,
          contractNum: this.$route.params.contractNum,
          erpOrderNumber: _items[0].erpOrderNumber,
          salesType: this.salesType,
          userId: this.$store.state.user.userId,
          erpLineIdList: _items.map(item => item.lineId)
        };

        let oldNewKey = val.province + val.city + val.county + val.receiptAddress;
        this.addressList[oldNewKey] = this.addressList[this.keyAddress];
        let oldErpOrderNumber = this.addressList[this.nowAddressIndex]?.erpOrderNumber;
        if (this.keyAddress) {
          oldErpOrderNumber = this.addressList[this.keyAddress][0]?.erpOrderNumber;
        }
        // delete this.addressList[this.keyAddress];
        let oldParams = {
          receiptAddressId: val.id,
          contractNum: this.$route.params.contractNum,
          erpOrderNumber: oldErpOrderNumber,
          salesType: this.salesType
        };

        Promise.all([
          updateContractReceiptAddress(oldParams),
          updateContractReceiptAddressByLine(params)
        ]).then((res) => {
          if (res[0].data.status === '200' && res[1].data.status === '200') {
            this.addressList[newKey] = this.addressList[this.keyAddress];
            delete this.addressList[this.keyAddress];
            this.$message.success('同步ERP地址成功');
            this.showAddress = false;
          }
        });
        return;
      }
      if (!this.isInternational) {
        let newKey = val.province + val.city + val.county + val.receiptAddress + val.receiverName + val.receiverPhone;
        const _items = this.addressList[this.keyAddress];
        let params = {
          receiptAddressId: val.id,
          contractNum: this.$route.params.contractNum,
          erpOrderNumber: _items[0].erpOrderNumber,
          salesType: this.salesType,
          userId: this.$store.state.user.userId,
          erpLineIdList: _items.map(item => item.lineId)
        };
        updateContractReceiptAddressByLine(params).then((res) => {
          if (res.data.status === '200') {
            this.addressList[newKey] = this.addressList[this.keyAddress];
            delete this.addressList[this.keyAddress];
            this.$message.success('同步ERP地址成功');
            this.showAddress = false;
          }
        });
        return;
      }
      let newKey = val.province + val.city + val.county + val.receiptAddress;
      this.addressList[newKey] = this.addressList[this.keyAddress];
      let erpOrderNumber = this.addressList[this.nowAddressIndex]?.erpOrderNumber;
      if (this.keyAddress) {
        erpOrderNumber = this.addressList[this.keyAddress][0]?.erpOrderNumber;
      }
      // delete this.addressList[this.keyAddress];
      let params = {
        receiptAddressId: val.id,
        contractNum: this.$route.params.contractNum,
        erpOrderNumber: erpOrderNumber,
        salesType: this.salesType
      };
      updateContractReceiptAddress(params).then((res) => {
        if (res.data.status === '200') {
          this.$message.success('同步ERP地址成功');
          this.showAddress = false;
        }
      });
    },
    initData () {
      this.loading = true;
      let params = { contractNum: this.strContractCode };
      if (!this.isInternational) {
        queryOrderInfoFromDsDataByAddress(params)
          .then(res => {
            let { status, data } = res.data;
            this.loading = false;
            if (status === '200') {
              this.addressList = data;
              this.isNoData = !Object.keys(data).length;
              Object.keys(data).forEach(key => {
                this.allList = [...this.allList, ...data[key]];
              });
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        queryOrderInfoFromDsData(params)
          .then(res => {
            let { status, data } = res.data;
            this.loading = false;
            if (status === '200') {
              this.addressList = data;
              this.isNoData = !data.length;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    updateAddress (val, index, key) {
      this.nowAddressIndex = index;
      this.keyAddress = key;
      this.showAddress = true;
    },

    // 合计
    getSummaries ({ columns, data }, row) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          if (!this.isInternational) {
            sums[index] = '小计';
          } else {
            sums[index] = '合计';
          }
          return;
        }
        if (column.label === '数量') {
          sums[index] = row.totalCount;
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(numToFixed(cur.addTaxesPrice, 2)).plus(pre).toString()), 0);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = numToFixed(row.totalAmount);
          return;
        }
        if (column.label === '已发货数量') {
          sums[index] = row.totalShippedCount;
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(numToFixed(cur.unShippedCount, 0)).plus(pre).toString()), 0);
          return;
        }
        if (column.label === '销退数量') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(numToFixed(cur.sellingBack, 0)).plus(pre).toString()), 0);
        }
      });
      return sums;
    },
    getSummariesAll (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = 0;
          this.allList.forEach(item => {
            sums[index] += Number(item.count) || 0;
          });
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = 0;
          this.allList.forEach(item => {
            sums[index] += Number(item.addTaxesPrice) || 0;
          });
          sums[index] = sums[index].toFixed(2);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = 0;
          this.allList.forEach(item => {
            sums[index] += Number(item.amount) || 0;
          });
          sums[index] = sums[index].toFixed(2);
        }
      });
      return sums;
    }
  }
};
</script>

<style scoped>
.mr-10{
  margin-right: 10px;
}

.marginBottom{
  margin: 15px 10px;
}

:deep(#totalTable){
}

:deep(#totalTable > div){
  display: none !important;
}

:deep(#totalTable .el-table__footer-wrapper){
  display: block!important;
}

:deep(#totalTable .el-table__cell:first-child .cell){
  visibility: visible!important;
}

:deep(.rj-Collapse__body){
  /* border: 1px solid #EBEEF5; */
}
</style>
